import { render } from "./ListeFacture.vue?vue&type=template&id=6a2ec35a&ts=true"
import script from "./ListeFacture.vue?vue&type=script&lang=ts"
export * from "./ListeFacture.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__